/*eslint-disable no-throw-literal*/
import * as endpoints from '@App/constants/endpoints';
import interceptor from '../interceptor';

const TOKENS = 'tokens';
const CONFIG = 'config';
const TOKEN = 'token';
const ACCOUNTS = 'accounts';
const CREDITS = 'credits';
const MONTHLY = 'monthly';
const TRANSACTIONS = 'transactions';
const MANAGER = 'manager';
const ACCOUNT = 'account';

const _get = async props => {
    const { axios, pathUrl } = props;

    try {
        return (await axios.get(pathUrl)).data;
    } catch (error) {
        if (error && error.response && error.response.status)
            throw {
                status: error.response.status,
                userFeedback: error.response.data.userFeedback,
            };
        throw error;
    }
};

const _post = async (axios, pathUrl, params = {}) => {
    try {
        return (await axios.post(pathUrl, params)).data;
    } catch (error) {
        if (error && error.response && error.response.status)
            throw {
                status: error.response.status,
                userFeedback: error.response.data.userFeedback,
                ...error.response.data
            };
        throw error;
    }
};

const _put = async (axios, pathUrl, params = {}) => {
    try {
        return (await axios.put(pathUrl, params)).data;
    } catch (error) {
        if (error && error.response && error.response.status)
            throw {
                status: error.response.status,
                userFeedback: error.response.data.userFeedback,
            };
        throw error;
    }
};

//#region GET
export const getTokensConfig = async ({ header }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TOKEN}/${CONFIG}`;
    const axios = interceptor(header);
    return await _get({ axios, pathUrl });
};

export const getAccountTokens = async ({ accountId, header }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TOKEN}/${ACCOUNTS}/${accountId}/${TOKENS}`;
    const axios = interceptor(header);
    return await _get({ axios, pathUrl });
};

export const getTokenTransactions = async ({ accountId, header }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TOKEN}/${ACCOUNTS}/${accountId}/${TOKENS}/${TRANSACTIONS}`;
    const axios = interceptor(header);
    return await _get({ axios, pathUrl });
};

export const getDashboardMetrics = async ({ month, year, header }) => {
    const queryParams = [];
    if (month) queryParams.push(`month=${month}`);
    if (year) queryParams.push(`year=${year}`);
    
    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
    const pathUrl = `${endpoints.API_ACCOUNT}/${TOKEN}/dashboard/tokens/metrics${queryString}`;
    const axios = interceptor(header);
    
    return await _get({ axios, pathUrl });
};
//#endregion

//#region PUT
export const updateTokensConfig = async params => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TOKEN}/${CONFIG}`;
    const axios = interceptor();
    return await _put(axios, pathUrl, params);
};
//#endregion

//#region POST
export const addTokenCredits = async ({ accountId, params }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TOKEN}/${ACCOUNTS}/${accountId}/${TOKENS}/${CREDITS}`;
    const axios = interceptor();
    return await _post(axios, pathUrl, params);
};

export const addMonthlyPlan = async ({ accountId, params }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TOKEN}/${ACCOUNTS}/${accountId}/${TOKENS}/${MONTHLY}`;
    const axios = interceptor();
    return await _post(axios, pathUrl, params);
};
//#endregion

//#region USER TOKEN LIMITS
const USERS = 'users';
const LIMIT = 'limit';

export const getAccountUsers = async ({ accountId, header }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${MANAGER}/${ACCOUNT}/${accountId}/${USERS}`;
    const axios = interceptor(header);
    return await _get({ axios, pathUrl });
};

export const getUserTokenLimit = async ({ accountId, userId, header }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TOKEN}/${ACCOUNTS}/${accountId}/${USERS}/${userId}/${LIMIT}`;
    const axios = interceptor(header);
    return await _get({ axios, pathUrl });
};

export const updateUserTokenLimit = async ({ accountId, userId, params }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TOKEN}/${ACCOUNTS}/${accountId}/${USERS}/${userId}/${LIMIT}`;
    const axios = interceptor();
    return await _post(axios, pathUrl, params);
};
//#endregion

//#region PLANS
const PLAN = 'plan';

export const getAccountPlan = async ({ accountId, header }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TOKEN}/${ACCOUNTS}/${accountId}/${PLAN}`;
    const axios = interceptor(header);
    return await _get({ axios, pathUrl });
};

export const updateAccountPlan = async ({ accountId, planId, selectedAgents }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TOKEN}/${ACCOUNTS}/${accountId}/${PLAN}`;
    const axios = interceptor();
    return await _put(axios, pathUrl, { planId, selectedAgents });
};

const _delete = async (axios, pathUrl) => {
    try {
        return (await axios.delete(pathUrl)).data;
    } catch (error) {
        if (error && error.response && error.response.status)
            throw {
                status: error.response.status,
                userFeedback: error.response.data.userFeedback,
            };
        throw error;
    }
};

export const cancelAccountPlan = async ({ accountId }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${TOKEN}/${ACCOUNTS}/${accountId}/${PLAN}`;
    const axios = interceptor();
    return await _delete(axios, pathUrl);
};
//#endregion
